module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "divider"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1 col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-8"
  }, [_c('h2', {
    staticClass: "wow bounce mark-primary",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "wow fadeIn",
    attrs: {
      "data-wow-delay": "0.6s"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.subTitle)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "wow fadeInUp",
    attrs: {
      "data-wow-delay": "0.9s"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.details)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "wow fadeInUp",
    attrs: {
      "data-wow-delay": "0.9s"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.more)
    }
  }), _vm._v(" "), _c('tryBtn')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f498e18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/divider.vue
// module id = 698
// module chunks = 0